import Vue from 'vue';
import { mapGetters } from 'vuex';
import friggUtils from '@/utils/friggUtils';
import { StoreObject } from '@/store/storeObject';
import { Post } from '@/models/dtos';

export default Vue.extend({
	props: {
		postId: {
			type: Number,
			required: true,
		},
	},
	computed: {
		...mapGetters(['postById']),
		post(): StoreObject<Post> {
			return (this as any).postById(this.postId);
		},
	},
	async created() {
		await this.$store.dispatch('loadPostById', this.postId);
	},
	metaInfo() {
		const self = this as any;
		const post = self.post;
		const ret = {
			title: '',
			meta: [] as any[],
		};
		if (post != null && post.data != null) {
			const data = post.data;
			ret.title = data.values.default_browsertitle || data.name;
			ret.meta = friggUtils.getMetaDataArrayFromMetaObject(data.meta);
		}
		return ret;
	},
});
